(function () {
  function init() {
    var termsNav = document.querySelector('.js-terms-nav');
    var termsContent = document.querySelector('.js-terms-content');
    var isDesktop = window.innerWidth >= 750;
    var desktopOffsetPx = 130;

    // A. ScrollTrigger pin for left nav (desktop only)
    if (termsNav && termsContent && typeof ScrollTrigger !== 'undefined' && isDesktop) {
      ScrollTrigger.create({
        trigger: termsNav,
        start: 'top ' + desktopOffsetPx + 'px',
        endTrigger: termsContent,
        end: 'bottom bottom',
        pin: true,
        pinSpacing: false
      });
    }

    // B. Click → scroll to policy section
    var navLinks = document.querySelectorAll('.js-terms-nav-link');
    navLinks.forEach(function (link, index) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        lockActiveState(index);
        var targetId = link.getAttribute('data-target');
        var target = document.getElementById(targetId);
        if (!target) return;
        var smoother = typeof ScrollSmoother !== 'undefined' ? ScrollSmoother.get() : null;
        if (smoother) {
          smoother.scrollTo(target, true, 'top 130px');
        } else {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });

    // C. Active state on scroll
    var navItems = document.querySelectorAll('.terms__nav-item');
    var policyEls = document.querySelectorAll('.js-terms-policy');
    var isProgrammaticScroll = false;
    var scrollLockTimer = null;

    function setActive(index) {
      navItems.forEach(function (item) {
        item.classList.remove('is-active');
      });
      if (navItems[index]) {
        navItems[index].classList.add('is-active');
      }
    }

    function lockActiveState(index) {
      isProgrammaticScroll = true;
      setActive(index);

      if (scrollLockTimer) {
        clearTimeout(scrollLockTimer);
      }

      scrollLockTimer = setTimeout(function () {
        isProgrammaticScroll = false;
        setActive(index);
      }, 800);
    }

    policyEls.forEach(function (policyEl, index) {
      ScrollTrigger.create({
        trigger: policyEl,
        start: isDesktop ? ('top top+=' + desktopOffsetPx) : 'top 30%',
        end: isDesktop ? ('bottom top+=' + desktopOffsetPx) : 'bottom 30%',
        onToggle: function (self) {
          if (isProgrammaticScroll) return;
          if (self.isActive) setActive(index);
        },
        onEnter: function () {
          if (isProgrammaticScroll) return;
          setActive(index);
        },
        onEnterBack: function () {
          if (isProgrammaticScroll) return;
          setActive(index);
        }
      });
    });

    function setInitialActiveFromViewport() {
      if (!policyEls.length) return;

      var markerY = isDesktop ? desktopOffsetPx : (window.innerHeight * 0.3);
      var activeIndex = 0;

      for (var i = 0; i < policyEls.length; i += 1) {
        var rect = policyEls[i].getBoundingClientRect();
        if (rect.top <= markerY) {
          activeIndex = i;
        }
      }

      setActive(activeIndex);
    }

    // Initialize using the section currently crossing the trigger marker.
    setInitialActiveFromViewport();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
